// extracted by mini-css-extract-plugin
export var callCard = "_s1-0";
export var callMessageButton = "_s1-1";
export var helpIcon = "_s1-3";
export var helpIconContainer = "_s1-4";
export var verticalDivider = "_s1-2";